import useCore from './useCore';

export default useCore;